import React, { useEffect, useState } from "react"
import { OverlayTrigger, Popover, Button, Modal, Col, Form, Row } from 'react-bootstrap';
import { v4 as uuid } from "uuid";
import { ToastContainer, toast } from "react-toastify";
import { configData } from '../../config/systemconfigurationconstants';
import * as AWS from 'aws-sdk';
import { useEncryption } from '../../customHooks/useEncryption';
const CreateLoan = ({ show, handleClose, usecaseListForLoanCreations, clientListForLoanCreations, admindetailsFromMain,createLoanUsecaseid, createLoanClientid, loanDetatils, isNewLoan }) => {
   const { encrypt, decrypt } = useEncryption();
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
  };
    // let selectedfiles = [],
    let createLoanFlag = isNewLoan,
        listOfUsecases = [],
        admindetails = admindetailsFromMain,
        usecaseListForLoanCreation = usecaseListForLoanCreations,
        clientListForLoanCreation = clientListForLoanCreations;
    const [existLoanGuid, setExistLoanGuid] = useState(loanDetatils);
    useEffect(() => {
        console.log(admindetailsFromMain, "admindetailsFromMain")
        console.log(loanDetatils, "admindetailsFromMain")
        if (loanDetatils === null) {
            setExistLoanGuid(null)
            createLoanFlag = true;
        }
        else {
            setExistLoanGuid(loanDetatils?.CLN)
            createLoanFlag = false;
        }
    }, [loanDetatils])
    // Create new loan
    const [selectedfiles, setSelectedfiles] = useState([]);
    const [selectedUsecaseFrLnCreation, setSelectedUsecaseFrLnCreation] = useState("UCSN");
    const [fileSelected, setFileSelected] = useState([]);
    const [listOfSelectedfiles, setListOfSelectedfiles] = useState([]);
    const [lengthOfSelectedFiles, setLengthOfSelectedFiles] = useState(0);
    const [submitted, setSubmitted] = useState(false);
    const [listOfFileNames, setListOfFileNames] = useState([]);
    const [fileNameWithOutExten, setFileNameWithOutExten] = useState([]);
    const [createLoanUsecase, setCreateLoanUsecase] = useState(createLoanUsecaseid);
    const [createLoanClient, setCreateLoanClient] = useState(createLoanClientid);
    const [loanfields, setLoanfields] = useState([]);
    const [disableClientForLoanCreation, setDisableClientForLoanCreation] = useState(false);

    const [loanInfo, setLoanInfo] = useState({
        External_BatchId: "",
        loans: [],
    });
    const [loan, setLoan] = useState({
        loanGuid: "",
        Loanfields: [],
    });
    let globalLoan = { loanGuid: "", Loanfields: [] },
        globalLoanInfo = { External_BatchId: "", loans: [] },
        globalLoanfields = [];
    function selectFile(event) {
        // Create a new array from the existing selected files
        const newSelectedFiles = Array.from(event.target.files);

        // Use the functional form of setSelectedfiles to ensure you are working with the latest state
        setSelectedfiles(prevSelectedFiles => {
            const updatedSelectedFiles = [...prevSelectedFiles, ...newSelectedFiles];

            // Update other states based on the new selected files
            setFileSelected(updatedSelectedFiles);
            setListOfSelectedfiles(updatedSelectedFiles);
            setLengthOfSelectedFiles(updatedSelectedFiles.length);

            return updatedSelectedFiles; // Return the updated state
        });

        // Reset the input value
        event.target.value = null;
        // for (var i = 0; i < event.target.files.length; i++) {
        // Create a new array from the existing selected files
        // const newSelectedFiles = Array.from(event.target.files);

        // Combine the new files with the previously selected files
        // setSelectedfiles([...selectedfiles, ...newSelectedFiles]);
        // selectedfiles.push(event.target.files[i]);

        // }

        // setFileSelected(selectedfiles);
        // setListOfSelectedfiles(selectedfiles);
        // setLengthOfSelectedFiles(selectedfiles.length);
        // event.target.value = null;
    }
    function removeSelectedFile(index) {
        console.log("removeSelectedFile() - index", index);
        if (fileSelected != null || fileSelected != "undefined") {
            // var files = fileSelected.splice(index, 1);
            var fileName = fileSelected[index].name;
            var files = fileSelected.filter(el => el.name != fileName);
            // selectedfiles = files;
            setSelectedfiles(files);
            setFileSelected(files);
            setListOfSelectedfiles(files);
            // listOfSelectedfiles.splice(index, 1);
            setLengthOfSelectedFiles(files.length);
        }
    }
    // Add files to loan
    function fileUpload() {
        // handleClose();
        console.log("selectUsecaseForLoanCreation()", selectedUsecaseFrLnCreation);
        console.log(
            "this.fileSelected.length " +
            fileSelected.length +
            " this.listOfSelectedfiles " +
            listOfSelectedfiles
        );
        setSubmitted(true);
        if (fileSelected.length <= 0) {

            return;
        }
        createJson();
    }
    function createJson() {
        globalLoanInfo.External_BatchId = "3101";
        setLoanInfo({
            ...loanInfo,
            External_BatchId: globalLoanInfo.External_BatchId,
        });


        // Add files to loan Fixes
        if (existLoanGuid != null) {
            globalLoan.loanGuid = existLoanGuid;
            setLoan({ ...loan, loanGuid: globalLoan.loanGuid });
            uploadFile();
        } else {
            for (let file of listOfSelectedfiles) {
                if (file.name.split(".").pop() === "csv") {
                    console.log("csv file");
                    convertFile(file);
                }
            }
        }
    }
    function uploadFile() {

        const file = listOfSelectedfiles[0];
        let inputJson = JSON.stringify(globalLoanInfo);
        console.log("uploadFile()", file);
        let docInfoJsonFile = "";

        let listOfFileNamesData = [];
        let fileNameWithOutExtension = [];
        for (let i = 0; i < lengthOfSelectedFiles; i++) {
            console.log(
                "filenme" + listOfSelectedfiles[i].name.split("?")[0].split(".").pop()
            );
            let temp = listOfSelectedfiles[i].name;
            listOfFileNamesData.push(temp);
            if (
                listOfSelectedfiles[i].name.split("?")[0].split(".").pop() === "pdf" || listOfSelectedfiles[i].name.split("?")[0].split(".").pop().toLowerCase() === "xml"

            ) {
                let temp1 = listOfSelectedfiles[i].name
                    .split(".")
                    .slice(0, -1)
                    .join(".");
                console.log("filesare " + temp1);
                fileNameWithOutExtension.push(temp1);
            }
            console.log(
                "fileNameWithOutExten.length",
                fileNameWithOutExtension.length
            );
        }
        setListOfFileNames(listOfFileNamesData);
        setFileNameWithOutExten(fileNameWithOutExtension);

        let docInfoFields = {
            loanId: "",
            documents: [],
        },
            docInfoDocument = {
                documentId: "",
                title: "",
                dateCreated: "",
                attachments: [],
            },
            docInfoAttachment = {
                entityId: "",
                entityName: "",
                entityUri: "",
                entityType: "",
            },
            changedFileNames = [];
        docInfoFields.loanId = globalLoan.loanGuid;
        var docInfoDocuments = [];
        for (let i = 0; i < listOfFileNamesData.length; i++) {
            if (
                listOfSelectedfiles[i].name.split("?")[0].split(".").pop() === "pdf" || listOfSelectedfiles[i].name.split("?")[0].split(".").pop().toLowerCase() === "xml"
            ) {
                var docInfoDo = {
                    documentId: "",
                    title: "",
                    dateCreated: "",
                    attachments: [],
                    application: {},
                };
                docInfoDo.documentId = uuid();
                docInfoDo.dateCreated = new Date();
                var filename = listOfSelectedfiles[i].name;
                docInfoDo.title = filename;

                var docinfAttach = {
                    entityId: "",
                    entityName: "",
                    entityUri: "",
                    entityType: "",
                };
                var uuidV = uuid();
                docinfAttach.entityId = listOfSelectedfiles[i].name.split("?")[0].split(".").pop() === "pdf" ? "Attachment-" + uuidV + ".pdf" : "Attachment-" + uuidV + ".xml";

                changedFileNames.push(docinfAttach.entityId);
                docinfAttach.entityName = listOfSelectedfiles[i].name;
                docinfAttach.entityType = "attachment";
                docinfAttach.entityUri =
                    "/v1/loans/" + uuidV + "/attachments/" + docinfAttach.entityId;
                docInfoDo.attachments.push(docinfAttach);
                docInfoDo.application = { legacyId: "_borrower1" };
                docInfoAttachment = docinfAttach;
                docInfoDocument = docInfoDo;
                docInfoDocuments.push(docInfoDocument);
            }
            docInfoFields.documents = docInfoDocuments;
        }
        console.log("DocInfo" + JSON.stringify(docInfoFields));
        for (let e = 0; e < changedFileNames.length; e++) {
            console.log("changedFileNames" + changedFileNames[e]);
        }
        console.log("changedFileNames.length", changedFileNames.length);
        let docInfo = [];
        docInfo.push(docInfoFields);
        docInfoJsonFile = JSON.stringify(docInfo);
        const formData = new FormData();
        var listofpdffiles = [];
        for (let k = 0; k < listOfSelectedfiles.length; k++) {
            if (
                listOfSelectedfiles[k].name.split("?")[0].split(".").pop() === "pdf" || listOfSelectedfiles[k].name.split("?")[0].split(".").pop().toLowerCase() === "xml"

            ) {
                listofpdffiles.push(listOfSelectedfiles[k]);
            }
        }
        for (let f = 0; f < listofpdffiles.length; f++) {
            formData.append("file", listofpdffiles[f], changedFileNames[f]);
        }
        var getAll = [];
        var filenames = [];
        getAll = formData.getAll("file");
        for (let g = 0; g < getAll.length; g++) {
            let name = getAll[g].name;
            console.log("getAll[g].value " + formData);
            filenames.push(name);
            console.log("names", filenames);
        }
        console.log("docInfoJsonFile " + docInfoJsonFile);
        let selectedUsecase = listOfUsecases.find(
            (el) => el.UseCaseId == createLoanUsecase
        );
        if (existLoanGuid === null) {
            createNewOder(inputJson, selectedUsecase, globalLoan.loanGuid)

                .then((response) => {
                    console.log("CreateNewOder-loaninfo-RES", response);
                    handleClose();
                    toast.success("Loan created successfully", {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });

                    setTimeout(() => {
                        uploadDocInfoJson(
                            docInfoJsonFile,
                            globalLoan.loanGuid,
                            selectedUsecase
                        )

                            .then((response) => {
                                console.log("CreateNewOder-uploadDocInfoJson-RES", response);
                                // handleClose();
                                toast.success("Doc Info Json uploaded successfully", {
                                    position: "bottom-center",
                                    autoClose: 2000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "colored",
                                });

                                setTimeout(() => {
                                    for (let i = 0; i < filenames.length; i++) {
                                        var fileNameToUpload = filenames[i];
                                        uploaddocs(
                                            listofpdffiles[i],
                                            fileNameToUpload,
                                            selectedUsecase
                                        )
                                            .then((response) => {
                                                handleClose();
                                                console.log("CreateNewOder-uploaddocs-RES", response);
                                                if (i === filenames.length - 1) {
                                                    toast.success("Orders created Successfully", {
                                                        position: "bottom-center",
                                                        autoClose: 2000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                        theme: "colored",
                                                    });
                                                    globalLoan = { loanGuid: "", Loanfields: [] };
                                                    globalLoanInfo = { External_BatchId: "", loans: [] };
                                                    globalLoanfields = [];
                                                    setListOfSelectedfiles([]);
                                                    setExistLoanGuid(null);
                                                    // selectedfiles = [];
                                                    setSelectedfiles([]);
                                                }
                                            })
                                            .catch((err) => {
                                                console.log("CreateNewOder err " + err);
                                            });
                                    }
                                }, 5000);
                            })
                            .catch((err) => {
                                console.log("CreateNewOder err " + err);
                            });
                    }, 5000);
                })
                .catch((err) => {
                    console.log("CreateNewOder err " + err);
                });
        } else if (existLoanGuid != null) {
            setTimeout(() => {
                uploadDocInfoJson(
                    docInfoJsonFile,
                    globalLoan.loanGuid,
                    selectedUsecase
                )
                    // createNewOder(inputJson, selectedUsecase, globalLoan.loanGuid)
                    .then((response) => {
                        console.log("CreateNewOder-uploadDocInfoJson-RES", response);
                        handleClose();
                        toast.success("Doc Info Json uploaded successfully", {
                            position: "bottom-center",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });

                        setTimeout(() => {
                            for (let i = 0; i < filenames.length; i++) {
                                var fileNameToUpload = filenames[i];
                                uploaddocs(
                                    listofpdffiles[i],
                                    fileNameToUpload,
                                    selectedUsecase
                                )
                                    .then((response) => {
                                        handleClose();
                                        console.log("CreateNewOder-uploaddocs-RES", response);
                                        if (i === filenames.length - 1) {
                                            toast.success("Orders created Successfully", {
                                                position: "bottom-center",
                                                autoClose: 2000,
                                                hideProgressBar: true,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true,
                                                progress: undefined,
                                                theme: "colored",
                                            });
                                            globalLoan = { loanGuid: "", Loanfields: [] };
                                            globalLoanInfo = { External_BatchId: "", loans: [] };
                                            globalLoanfields = [];
                                            setListOfSelectedfiles([]);
                                            setExistLoanGuid(null);
                                            // selectedfiles = [];
                                            setSelectedfiles([]);
                                        }
                                    })
                                    .catch((err) => {
                                        console.log("CreateNewOder err " + err);
                                    });
                            }
                        }, 5000);
                    })
                    .catch((err) => {
                        console.log("CreateNewOder err " + err);
                    });
            }, 5000);
        }
    }
    function convertFile(file) {
        console.log("convertFile");
        const reader = new FileReader();
        reader.onload = () => {
            let text = reader.result;
            console.log("CSV: ", text);
            let csvToRowArray = text.split("\n");
            console.log("csvToRowArray: ", csvToRowArray);
            globalLoan.loanGuid = uuid();
            setLoan({ ...loan, loanGuid: globalLoan.loanGuid });
            // this.loan.Encompassfields = this.createLoanInfoJson(csvToRowArray); // for prod
            globalLoan.Loanfields = createLoanInfoJson(csvToRowArray);
            globalLoanInfo.loans = [
                {
                    // Encompassfields: globalLoan.Loanfields,
                    Loanfields: globalLoan.Loanfields,
                    loanGuid: globalLoan.loanGuid,
                },
            ];
            setLoan({ ...loan, Loanfields: globalLoan.Loanfields }); // for dev for pilot

            console.log("this.loanInfo " + JSON.stringify(loanInfo));
            uploadFile();
        };
        reader.readAsText(file);
    }
    function uploaddocs(formData, fileName, UseCase) {
        console.log("formdata", formData);
        let fileUploadResp;

        let clientArr = admindetails.UseCaseClientInfo[0].UseCase.find(
            (el) => el.UseCaseID == createLoanUsecase
        ).Client;
        let usecaseshrtname = admindetails.UseCaseClientInfo[0].UseCase.find(el => el.UseCaseID == createLoanUsecase).UseCaseShortName,
            clientshrtname = clientArr.find(el => el.ClientID == createLoanClient).ClientShortName;
        let bucketName = configData.BUCKET_NAME + "/" + clientshrtname + "_" + usecaseshrtname + "/DropFolder";


        // const file = FilePath;
        console.log("fileName", fileName);
        const objbucket = new AWS.S3({
            correctClockSkew: true,
            credentials: {

                accessKeyId: decrypt(getCookie('ak')),
secretAccessKey: decrypt(getCookie('sk'))
            },
        });
        return objbucket
            .upload({ Key: fileName, Bucket: bucketName, Body: formData })
            .promise();
    }
    function createNewOder(FilePath, UseCase, fileName) {
        console.log("UseCase", UseCase);
        let fileUploadResp;

        let clientArr = admindetails.UseCaseClientInfo[0].UseCase.find(
            (el) => el.UseCaseID == createLoanUsecase
        ).Client;
        let usecaseshrtname = admindetails.UseCaseClientInfo[0].UseCase.find(el => el.UseCaseID == createLoanUsecase).UseCaseShortName,
            clientshrtname = clientArr.find(el => el.ClientID == createLoanClient).ClientShortName;
        let bucketName = configData.BUCKET_NAME + "/" + clientshrtname + "_" + usecaseshrtname + "/DropFolder";

        console.log("CreateNewOder bucketName" + bucketName);
        const file = FilePath;
        const fName = "Loaninfo-" + fileName + ".json";
        console.log("fName " + fName);
        const objbucket = new AWS.S3({
            correctClockSkew: true,
            credentials: {

                accessKeyId: decrypt(getCookie('ak')),
secretAccessKey: decrypt(getCookie('sk'))
            },
        });
        return objbucket
            .upload({
                Key: "Loaninfo-" + fileName + ".json",
                Bucket: bucketName,
                Body: file,
            })
            .promise();
    }
    function uploadDocInfoJson(docInfoJsonFile, fileName, UseCase) {
        console.log("timeis", new Date());

        let clientArr = admindetails.UseCaseClientInfo[0].UseCase.find(
            (el) => el.UseCaseID == createLoanUsecase
        ).Client;
        let usecaseshrtname = admindetails.UseCaseClientInfo[0].UseCase.find(el => el.UseCaseID == createLoanUsecase).UseCaseShortName,
            clientshrtname = clientArr.find(el => el.ClientID == createLoanClient).ClientShortName;
        let bucketName = configData.BUCKET_NAME + "/" + clientshrtname + "_" + usecaseshrtname + "/DropFolder";

        console.log("uploadDocInfoJson bucketName" + bucketName);
        const objbucket = new AWS.S3({
            correctClockSkew: true,
            credentials: {

                accessKeyId: decrypt(getCookie('ak')),
secretAccessKey: decrypt(getCookie('sk'))
            },
        });
        var docInfoJsonPromise = objbucket
            .upload({
                Key: "Docinfo-" + fileName + ".json",
                Bucket: bucketName,
                Body: docInfoJsonFile,
            })
            .promise();
        docInfoJsonPromise
            .then((data) => {
                console.log("Success", data);
                console.log("uploadDonInfoJson-success");
            })
            .catch(function (err) {
                console.log(err);
            });
        return docInfoJsonPromise;
    }
    function createLoanInfoJson(csvToRowArray) {

        let row1 = csvToRowArray[0].split(",");
        let row3 = csvToRowArray[1].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
        console.log("row2", row3);
        console.log(
            "row2",
            row3.map((element) => element.replace(/[\"]/, ""))
        );
        let row2 = row3.map((element) => element.replace(/[\"]/g, ""));
        let loanfieldsInfo = [];
        for (let i = 0; i < row1.length; i++) {
            // this.encompassfields.push(new Encompassfield(row1[i].trim(), row2[i].trim())) // for prod
            loanfieldsInfo.push({
                fieldId: row1[i].trim(),
                fieldValue: row2[i].trim(),
            }); // for dev for pilot
            globalLoanfields.push({
                fieldId: row1[i].trim(),
                fieldValue: row2[i].trim(),
            }); // for dev for pilot
        }
        setLoanfields(globalLoanfields);
        // console.log('this.encompassfields ' + JSON.stringify(this.encompassfields)); // for  prod
        console.log("this.encompassfields " + JSON.stringify(loanfields)); // for dev for pilot
        // return this.encompassfields; // for prod
        // return loanfields; // for dev for pilot
        return globalLoanfields; // for dev for pilot
    }
    const createLoanUsecaseChange = (event) => {
        let value = event.target.value;
        if (value != "" && value > 0) {
            setCreateLoanUsecase(value);
            setDisableClientForLoanCreation(false);

        } else {
            setDisableClientForLoanCreation(false);
        }
    };
    const createLoanClientChange = (event) => {
        let value = event.target.value;
        if (value != "" && value > 0) {
            setCreateLoanClient(value);
        }
    };
    function checkListofItems() {
        if (listOfSelectedfiles != null || listOfSelectedfiles != "undefined") {
            return listOfSelectedfiles.length > 0;
        }
    }
    const handleClosepopup = () => {
        setFileSelected([]);
        setListOfSelectedfiles([]);
        setLengthOfSelectedFiles(0);
        // selectedfiles = [];
        setSelectedfiles([]);
        // event.target.value = null;
        // for(let i=0;i<fileSelected.length;i++)
        // {
        //     removeSelectedFile(i)
        // }
        handleClose();
    }
    return (
        <>
            <Modal show={show} onHide={handleClosepopup} className='modal-dialog-centered'>
                <Modal.Header closeButton>
                    {(createLoanFlag) && <Modal.Title>Create loan</Modal.Title>}
                    {(!createLoanFlag) && <Modal.Title>Add files to loan</Modal.Title>}
                </Modal.Header>
                <Modal.Body>

                    <Form>
                        <Row>
                            <Form.Group
                                as={Col}
                                sm="6"
                                controlId="usecaseforusercreation"

                            >
                                <Form.Label>Usecase</Form.Label>
                                <Form.Select
                                    size="sm"
                                    required
                                    value={createLoanUsecase}
                                    onChange={(event) => createLoanUsecaseChange(event)}
                                >
                                    <option value="">Select Usecase</option>
                                    {usecaseListForLoanCreation.map((el) => (
                                        <option value={el.UseCaseID}>{el.UseCaseName}</option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a usecase.
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group
                                as={Col}
                                sm="6"
                                controlId="clientforusercreation"

                            >
                                <Form.Label>Client</Form.Label>
                                <Form.Select
                                    size="sm"
                                    required
                                    value={createLoanClient}
                                    disabled={disableClientForLoanCreation}
                                    onChange={(event) => createLoanClientChange(event)}
                                >
                                    <option value="">Select Client</option>
                                    {clientListForLoanCreation.map((el) => (
                                        <option value={el.ClientID}>{el.ClientName}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Row>
                    </Form>
                    <br></br>
                    <Form.Group controlId="formFileMultiple" className="mb-3">
                        {/* <Form.Label>Choose Files</Form.Label> */}
                        <Form.Control size="sm" type="file" multiple accept=".xlsx, .xls, .pdf, .xml" onChange={selectFile} />
                    </Form.Group>
                    {checkListofItems && (
                        <Row>
                            {listOfSelectedfiles.map((el, index) => (
                                <div>
                                    {el && (
                                        <span>
                                            {el.name}{" "}
                                            <i
                                                style={{ fontSize: "18px", color: "#4DA9DE",cursor:"pointer" }}
                                                className="ri-delete-bin-line"
                                                onClick={() => removeSelectedFile(index)}
                                            ></i>
                                        </span>
                                    )}
                                </div>
                            ))}
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={handleClosepopup}>
                        Close
                    </Button>
                    {createLoanFlag ? <Button variant="primary" size="sm" onClick={fileUpload}>
                        Create
                    </Button> : <Button variant="primary" size="sm" onClick={fileUpload}>
                        Add Files
                    </Button>}
                </Modal.Footer>
            </Modal>
            <ToastContainer />
        </>
    )
}
export default CreateLoan